import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDelete24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m3 8c0-.563.438-1 1-1h1c1.094 0 2 .906 2 2v11h10v-11c0-1.094.906-2 2-2h1c.563 0 1 .438 1 1 0 .563-.438 1-1 1h-1v11c0 1.094-.906 2-2 2h-10c-1.094 0-2-.906-2-2v-11h-1c-.563 0-1-.438-1-1zm0-3c0-.563.438-1 1-1h4v-1c0-.563.438-1 1-1h6a1.017 1.017 0 0 1 1 1v1h4c.563 0 1 .438 1 1 0 .563-.438 1-1 1h-16c-.563 0-1-.438-1-1zm6 12v-7c0-.531.469-1 1-1 .563 0 1 .469 1 1v7c0 .531-.438 1-1 1-.563 0-1-.469-1-1zm4 0v-7c0-.531.469-1 1-1 .563 0 1 .469 1 1v7c0 .531-.438 1-1 1-.563 0-1-.469-1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDelete24;
